import { gql } from "@apollo/client";

export const CREATE_EVENT_BOOKING = gql`
	mutation CreateCustomerBooking($customerBooking: CustomerBookingInput!) {
		createCustomerBooking(input: { customerBooking: $customerBooking }) {
			clientMutationId
		}
	}
`;

export const GET_EVENT_BOOKINGS = gql`
	query GetCustomerBookings {
		myEventBookings {
			nodes {
				id
				event {
					name
				}
				eventDate
				eventStartTime
				eventEndTime
				numberOfGuests
			}
		}
	}
`;
